import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Plus } from "lucide-react";

const RecommendedSection = ({ recommendedItems, dispatch, jwt, addItemToCart }) => {
  const [localRecommended, setLocalRecommended] = useState([]);
  const [loadingItems, setLoadingItems] = useState([]);

  useEffect(() => {
    setLocalRecommended(recommendedItems);
  }, [recommendedItems]);

  const handleAddToCart = async (e, productId) => {
    e.stopPropagation();

    if (!productId) {
      toast.error("Product not found");
      return;
    }

    setLoadingItems((prev) => [...prev, productId]);

    try {
      const data = {
        productId,
        size: "ONE_SIZE",
        quantity: 1,
      };

      await dispatch(addItemToCart({ data, jwt }));
      dispatch({ type: "TRIGGER_SIDEBAR_RELOAD" });

      toast.success("Item added to cart!");
    } catch (error) {
      toast.error("Failed to add to cart");
      console.error("Add to cart error:", error);
    } finally {
      setLoadingItems((prev) => prev.filter((id) => id !== productId));
    }
  };

  return (
    <section className="recommended-section" aria-label="Recommended products you might also like">
      <h3>You might also like</h3>

      <div className="recommended-list">
        {localRecommended.map((item) => {
          const productId = item.id;
          const isLoading = loadingItems.includes(productId);

          return (
            <div
              key={productId}
              className="recommended-item relative"
              role="button"
              tabIndex={0}
              onClick={(e) => handleAddToCart(e, productId)}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleAddToCart(e, productId);
              }}
            >
              <img
                src={item.img}
                alt={item.alt}
                loading="lazy"
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.src = "fallback-image-url.png";
                }}
              />

              <div className="p-2 flex flex-col">
                <span className="font-medium">{item.name}</span>
                {item.price && (
                  <span className="text-sm text-gray-600">₹{item.price}</span>
                )}
              </div>

              <button
                style={{ position: "absolute", top: "95px", right: "10px" }}
                onClick={(e) => handleAddToCart(e, productId)}
                disabled={isLoading}
                className="bg-white/80 rounded-full p-1 shadow-md"
              >
                {isLoading ? (
                  <svg
                    className="animate-spin h-5 w-5 text-gray-800"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                    />
                  </svg>
                ) : (
                  <Plus className="w-5 h-5 text-gray-800" />
                )}
              </button>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default RecommendedSection;
